import React, { SetStateAction, useEffect, useState } from 'react';
import { Button, Form, Modal } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useAppDispatch } from 'app/store';
import { useRejectVacationMutation } from 'app/services/edpApiV1/vacations';
import { useNotifications } from 'shared/hooks/use-notifications';
import { getErrorData } from 'shared/helpers/utils';
import { VacationsModel } from 'entities/vacations';
import { TUnionTableData } from 'shared/types/types';

type TProps = {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  id: string | undefined;
  setSelectUser?: React.Dispatch<SetStateAction<TUnionTableData>>;
  setIsBtnGroupVisible?: React.Dispatch<React.SetStateAction<boolean>>;
  handleSubmit?: (text: string) => void;
  loading?: boolean;
};

export const VacationModal = ({
  openModal,
  setOpenModal,
  id,
  setSelectUser,
  setIsBtnGroupVisible,
  handleSubmit,
  loading,
}: TProps) => {
  const [modalText, setModalText] = useState<string>();
  const [form] = Form.useForm();
  const dispatch = useAppDispatch();

  const [triggerReject, resultReject] = useRejectVacationMutation({
    selectFromResult: result => ({ ...result, error: getErrorData(result.error) }),
  });

  const { isSuccess: rejectSuccess, isError: errorReject, error: errorMessage, reset: resetReject } = resultReject;

  const handleOk = () => {
    if (handleSubmit) {
      handleSubmit(modalText ?? '');
      setOpenModal(false);
      return;
    }
    if (modalText && modalText?.length > 0 && modalText !== '') {
      triggerReject({ requestId: Number(id), rejectionReason: modalText });
      setOpenModal(false);
      if (setIsBtnGroupVisible) setIsBtnGroupVisible(false);
    }
  };

  const handleCancel = () => {
    setOpenModal(false);
    setModalText('');
  };

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // если отсутствует текст, игнорирую пробелы и переносы строки клавищей "ENTER"
    if (!modalText) {
      setModalText(e.target.value.replace(/^\s+/g, ''));
    } else {
      setModalText(e.target.value);
    }
  };

  useEffect(() => {
    if (rejectSuccess) {
      dispatch(VacationsModel.SelectedVacation.actions.selectedVacation({ key: '0' }));
    }
    if (rejectSuccess && setSelectUser) {
      dispatch(VacationsModel.SelectedVacation.actions.selectedVacation({ key: '0' }));
      setSelectUser([]);
    }
  }, [rejectSuccess, dispatch, setSelectUser]);

  useNotifications(rejectSuccess, errorReject, 'Заявление успешно отклонено', errorMessage?.message, resetReject);

  return (
    <Modal
      title="Напишите причину отказа"
      visible={openModal}
      onCancel={handleCancel}
      footer={[
        <Button key="back" onClick={handleCancel}>
          Отмена
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk} disabled={!modalText} loading={loading}>
          Отправить
        </Button>,
      ]}
    >
      <Form name="rejectionForm" form={form}>
        <Form.Item rules={[{ required: true, message: 'Пожалуйста, введите текст' }]}>
          <TextArea
            required
            name="rejectionReason"
            placeholder="Причина отказа"
            rows={8}
            maxLength={300}
            minLength={1}
            showCount
            value={modalText}
            onChange={onChange}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
